import { c as _c } from "react/compiler-runtime";
// syncStripeCompanySetupIntent(
//   setupIntentId: String!
//   billingAddress: BillingAddressInput!
//   setAsDefault: Boolean = true
// ): StripePaymentMethod!

import { useMutation } from "@tanstack/react-query";
import { graphqlClient } from "@/lib/graphql-client";
import { graphql, VariablesOf } from "@/graphql";
const syncStripeCompanySetupIntentMutation = graphql(`
  mutation syncStripeCompanySetupIntent(
    $setupIntentId: String!
    $billingAddress: BillingAddressInput!
  ) {
    syncStripeCompanySetupIntent(
      setupIntentId: $setupIntentId
      billingAddress: $billingAddress
    ) {
      status
      id
    }
  }
`);
export type BillingAddressInput = VariablesOf<typeof syncStripeCompanySetupIntentMutation>["billingAddress"];
export type SyncStripeCompanyIntentInput = {
  setupIntentId: string;
  billingAddress: BillingAddressInput;
};
export function useSyncStripeCompanySetupIntent() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}
async function _temp(input) {
  return graphqlClient.request(syncStripeCompanySetupIntentMutation, input);
}